import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { PlayCircleFillIcon } from '@yonderland/andes-icons';
import { Carousel, CarouselContent, CarouselSlot, Icon, Thumbnail } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
export const LightBoxThumbSlider = ({ activeSlideIndex, alt, mediaCollection, onActiveSlideIndexChange, }) => {
    const [thumbApi, setThumbApi] = useState(null);
    const handleClick = (index) => () => {
        onActiveSlideIndexChange(index);
    };
    useEffect(() => {
        thumbApi === null || thumbApi === void 0 ? void 0 : thumbApi.scrollTo(activeSlideIndex);
    }, [activeSlideIndex, thumbApi]);
    const renderSlide = (image, index) => (_jsx(CarouselSlot, { children: _jsx(Thumbnail, { image: { source: image.sourceSet[ProductImageSizesPortraitEnum.thumb], alt }, hasBorder: true, state: activeSlideIndex === index ? 'active' : 'resting', onClick: handleClick(index), overlay: image.isVideo ? _jsx(Icon, { source: PlayCircleFillIcon, size: "sm", color: "inverse" }) : undefined }) }, `lb_thumb_${index}`));
    return (_jsx(Carousel, { testId: "light_box_thumb_slider", slideSize: 85, hideOverflow: true, setApi: setThumbApi, children: _jsx(CarouselContent, { children: mediaCollection.map(renderSlide) }) }));
};
